import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AppProviders } from './app/providers';
import { initI18n } from './shared/i18n';
import { bootPlatformBrand } from './shared/use-platform-brand';
import './index.css';

// Het laatst bekende platformmerk vóór de eerste render (MRK-2): geen flits in de stijl van UP2D8.
bootPlatformBrand();

const container = document.getElementById('root');
if (!container) throw new Error('Geen #root in index.html');

// De taal staat vast vóór de eerste render, zodat er geen Nederlandse flits komt bij een
// Franstalige of Engelstalige gebruiker.
void initI18n().then(() => {
  createRoot(container).render(
    <StrictMode>
      <AppProviders />
    </StrictMode>,
  );
});
